import { ICustomIconProps } from './types';

const IconTabTable: React.FC<ICustomIconProps> = ({ size = 16, className }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path d='M7.49998 7V14.6667H5.20665C2.77998 14.6667 1.33331 13.22 1.33331 10.7933V7H7.49998Z' fill='currentColor' />
    <path d='M14.6667 7V10.7933C14.6667 13.22 13.22 14.6667 10.7933 14.6667H8.5V7H14.6667Z' fill='currentColor' />
    <path
      d='M14.6666 5.20683V6.00016H1.33331V5.20683C1.33331 2.78016 2.77998 1.3335 5.20665 1.3335H10.7933C13.22 1.3335 14.6666 2.78016 14.6666 5.20683Z'
      fill='currentColor'
    />
  </svg>
);

export default IconTabTable;
